import { useEffect, useRef, useState } from "react";

import { CopyButton } from "~/components/CopyButton";
import { Input } from "~/components/input";
import { stripTagPrefix } from "~/utils";
import { namespacePrefix } from "~/utils/namespacePrefix";

export function StoragePrefixForm() {
  const [orgId, setOrgId] = useState("");
  const [namespace, setNamespace] = useState("");
  const [prefix, setPrefix] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const orgInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setTimeout(() => orgInputRef.current?.focus(), 50);
  }, []);

  useEffect(() => {
    // Same Datadog tag paste normalization as org/namespace search.
    const normalizedOrg = stripTagPrefix(orgId);
    const normalizedNamespace = stripTagPrefix(namespace);
    if (!normalizedOrg || !normalizedNamespace) {
      setPrefix(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setError(null);
    void namespacePrefix(normalizedOrg, normalizedNamespace)
      .then((result) => {
        if (!cancelled) setPrefix(result);
      })
      .catch(() => {
        if (!cancelled) {
          setPrefix(null);
          setError("Failed to compute storage prefix");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [orgId, namespace]);

  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="storage_prefix_org_id" className="mb-1 block text-sm">
          Organization ID
        </label>
        <Input
          ref={orgInputRef}
          id="storage_prefix_org_id"
          type="text"
          value={orgId}
          onChange={(e) => setOrgId(e.target.value)}
          placeholder="e.g. test-mx7orjffhfx600bus75r86uv"
          autoComplete="off"
          spellCheck={false}
        />
      </div>
      <div>
        <label
          htmlFor="storage_prefix_namespace"
          className="mb-1 block text-sm"
        >
          Namespace
        </label>
        <Input
          id="storage_prefix_namespace"
          type="text"
          value={namespace}
          onChange={(e) => setNamespace(e.target.value)}
          placeholder="e.g. my-namespace"
          autoComplete="off"
          spellCheck={false}
        />
      </div>

      {error ? <p className="text-sm text-red-600">{error}</p> : null}

      {prefix ? (
        <div>
          <label className="mb-1 block text-sm">Storage prefix</label>
          <div className="group relative">
            <div className="break-all rounded bg-gray-100 p-2 pr-10 font-mono text-xs text-gray-700">
              {prefix}
            </div>
            <CopyButton
              value={prefix}
              label="Copy storage prefix"
              className="absolute right-2 top-2"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
